import { useContext, useState } from "react";
import { hideModal } from "../../../context/Actions/modal/modal";
import { PortalContext } from "../../../context/Provider";
import { ContaierPublicidad, PublicidadBody, PublicidadTop } from "./localStyle";

const Publicidad = ({publicidad}) => {
    const {modalDispatch} = useContext(PortalContext); 
    const [index, setIndex] = useState(0);

    let banner = publicidad[index]; 
    const handleClick = () => {
       if(publicidad[index + 1]){
        setIndex(index + 1);
       }else {
        localStorage.setItem("publicidad_portal", "true"); 
        hideModal()(modalDispatch)
       }
    }

    
    
    return (
        <ContaierPublicidad>
            <PublicidadTop>
                <span dangerouslySetInnerHTML={{__html: banner.nombre}} /> 
            </PublicidadTop>
            <PublicidadBody>
                <span dangerouslySetInnerHTML={{__html: banner.descripcion}} /> 
            </PublicidadBody>
            <button onClick={handleClick}>Continuar</button>
        </ContaierPublicidad>
    )
}

export default Publicidad;